export const defaultFinancialSupportPrograms = [
  {
    id: 'seed-agricultural-credit',
    programName: 'Agricultural Credit',
    type: 'Credit',
    provider: 'National Bank',
    region: 'India',
    status: 'ACTIVE',
    validity: '1/1/2026 - 12/31/2026',
    lastUpdated: '1/1/2026',
    basicInfo: {
      programName: 'Agricultural Credit',
      supportType: 'Credit',
      serviceProvider: 'National Bank',
      region: 'India',
      currency: 'INR',
      validityStart: '2026-01-01',
      validityEnd: '2026-12-31',
      description: 'Credit program to support agricultural working capital, inputs, and equipment needs.',
    },
    contributionRules: {
      setupFeeContributionRequired: true,
      setupFeePercentage: 20,
      subscriptionFeeContributionRequired: false,
      subscriptionFeePercentage: 0,
    },
    plans: [
      {
        id: 'seed-plan-growth-credit',
        planName: 'Growth Credit',
        supportType: 'Credit',
        planAmount: 500000,
        currency: 'INR',
        planStatus: 'Active',
        description: 'Working capital support for seasonal farming operations and input purchases.',
        interestRateApplicable: true,
        interestRate: 12,
        repaymentDurationApplicable: true,
        repaymentDuration: 12,
        numberOfInstallmentsApplicable: true,
        numberOfInstallments: 12,
        paymentFrequencyApplicable: true,
        paymentFrequency: 'Monthly',
        gracePeriodApplicable: true,
        gracePeriod: 30,
        processingFeeAmountApplicable: true,
        processingFeeAmount: 1500,
        latePaymentFeeAmountApplicable: true,
        latePaymentFeeAmount: 500,
        collateralRequiredApplicable: true,
        collateralRequired: 'Yes',
        collateralDetails: 'Land record or warehouse receipt',
        maximumCoveragePercentageApplicable: false,
        maximumCoveragePercentage: null,
        matchingContributionRequiredApplicable: false,
        matchingContributionRequired: null,
        matchingContributionPercentage: null,
        disbursementScheduleApplicable: false,
        disbursementSchedule: null,
        customDisbursementSchedule: null,
        equityRevenueShareApplicable: false,
        equityRevenueShare: null,
        expectedReturnRateApplicable: false,
        expectedReturnRate: null,
        exitVestingPeriodApplicable: false,
        exitVestingPeriod: null,
        eligibilityCriteria: 'Registered farmer with active cultivation records.',
        disbursementConditions: 'Disbursement after identity, land, and bank verification.',
        repaymentNotes: 'Monthly repayment schedule with a 30-day grace period.',
        otherConditions: 'Available only in selected agricultural districts.',
      },
    ],
  },
];

export function getFinancialSupportProgramsCatalog(persistedPrograms = []) {
  const uniquePrograms = new Map();

  [...persistedPrograms, ...defaultFinancialSupportPrograms].forEach((program) => {
    if (!program?.id) return;
    if (!uniquePrograms.has(program.id)) {
      uniquePrograms.set(program.id, program);
    }
  });

  return Array.from(uniquePrograms.values());
}
